module.exports = __webpack_public_path__ + "loanchat-logo.e6259c8.png";